import {
  FeeLevel,
  InputAmount,
  GasFeeInfo,
  GasPriceDetail,
  CoinInfo,
  CommonWalletInfo,
} from './common';
import { type CheckSignResponse } from '@/services/lombard';
export type PostStakeFeeParams = {
  poolId: number;
  chainCode: string;
  poolCode: string;
  poolType: string;
  amounts: InputAmount[];
  slippage: number;
  level: FeeLevel;
  minOutAmount?: string;
  router?: string;
};

export type PostStakeFeeRes = {
  gas: GasFeeInfo;
};

export type PostStakeParams = {
  poolId: number;
  chainCode: string;
  poolCode: string;
  amounts: object[];
  poolType: string;
  slippage: string;
  estimateFee: number[];
  gasLimit: number;
  baseFee: number;
  priority: number;
  gasMax: number;
  maxPriorityFeePerGas: number;
  minOutAmount?: string;
  router?: string;
};

export type PostStakeEncodeParams = CommonWalletInfo & {
  poolId: number;
  slippage?: string;
  stakeTokens: object[];
  minOutAmount?: string;
  router?: string;
  lombardStakeExtra?: LombardExtra;
};

export interface LombardExtra {
  fromBtcAddress: string;
  toBtcAddress: string;
  btcChainId: number;
}

export enum StakeEncodeStage {
  ApproveAmount = 11, //币授权金额阶段
  ApproveTrade = 19, //币授权交易阶段
  UnKnow = 0, //未知阶段
}

export type PostStakeEncodeRes = {
  orderCode: string;
  stage: StakeEncodeStage;
  txDataList: Array<{
    data: string;
    from: string;
    gasLimit: string;
    to: string;
    value: string;
    gasFee: string;
    gasPrice: string;
  }>;
};

export type PostSaveStakeOrderParam = PostStakeEncodeParams & {
  stage: StakeEncodeStage;
  // 是否广播 null，0-不广播 1-广播
  broadcast?: number;
  broadcastData?: {
    signData: string;
    chainId: number;
    from: string;
    to: string;
    value: string;
    txHash: string;
  }[];
  orderCode?: string;
  walletId?: string;
  useThirdConfig?: boolean;
  walletType?: number;
};

export type PostSaveStakeOrderRes = {
  orderCode: string;
  orderTxId: number;
};

export type GasStore = {
  level: FeeLevel;
  amount: string;
  price: string;
  gasPrice: string;
  estimateFee: string;
  priority: string;
  max: string;
  symbol: string;
  limit: string;
  isLoading: boolean;
  hasGasFee: boolean;
  loopPercent: number;
  isGreatThanProfit: boolean;
};

export type StakeOption = {
  slippage: string;
  supportWallets: number[];
  stakeAmount: string;
  stakeStage: StakeEncodeStage;
  currentStakeToken: CoinInfo;
  gasFeeInfo: Partial<GasFeeInfo>;
  selectedGasFeeInfo: GasPriceDetail;
  balance: string;
  gasFeeLevel: FeeLevel;
  nativeBalance: string;
  inputErrorText: string;
  gasFeeIsLoading: boolean;
  gasToken: CoinInfo;
  aprPerDay: string;
  gasFeePrice: string;
  process: Process;
  confirmButtonIsLoading: boolean;
  gasStore: GasStore;
  stakeLpInfo: Partial<CoinInfo>;
  isLombardSignAvailable?: boolean;
  signState?: CheckSignResponse;
  onChangeStakeStage: (v: StakeEncodeStage) => void;
  onChangeButtonLoading: (v: boolean) => void;
  onChangeStakeAmount: (v: string) => void;
  onChangeTextIsError: (v: boolean) => void;
  onChangeTextError: (v: string) => void;
  onChangeProcess: (v: Process) => void;
  onChangeShowConfirm: (v: boolean) => void;
  onChangeShowDisclaime: (v: boolean) => void;
  onChangeShowGasFeeTip: (v: boolean) => void;
  onSuccess: () => void;
};

export enum ApproveFailType {
  CANCEL = 1,
  UN_KNOWN = 2,
}

export enum StakeType {
  Common = 'common',
  Restaking = 'restaking',
}

export type PostLpAmountParams = {
  poolId: number;
  poolCode: string;
  poolType: string;
  slippage: number;
  coinList: [
    {
      amount: string;
      contractAddress: string;
    },
  ];
};

export type GetStakeEstimateTokenParam = {
  poolId: number;
  slippage: string;
  stakeTokens: [
    {
      amount: string;
      contractAddress: string;
    },
  ];
};

export type GetStakeEstimateTokenRes = {
  lpAmount: string;
  lpCoinDetail: CoinInfo;
  router: string;
};

export enum SlippageType {
  // 没有滑点
  None,
  // 固定滑点
  Solid,
  // 动态可设置滑点
  Dynamic,
}

export enum Process {
  None,
  Disclaime,
  GasFeeTip,
  Confirm,
  Result,
}
